package modysy.simulation.collision

import modysy.model.{GameObject, Portal}

object PortalResolver {
  var portalEpsilon: Double = 50 * 50

  def resolve(objects: Seq[GameObject],
              portals: Seq[(Portal, Portal)]): Unit = {
    for (portalPair <- portals; obj <- objects)
      if ((portalPair._1.body.pose.translation - obj.body.pose.translation).squaredNorm < portalEpsilon)
        obj.body.pose.translate(
          portalPair._2.body.pose.translation - obj.body.pose.translation)
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/simulation/collision/PortalResolver.scala